import React from 'react';
import { connect } from 'react-redux';
import { Header as SemanticHeader, Grid } from 'semantic-ui-react';
import { AppHeaderControls, AppHeaderLogo } from 'Components';
import { DirtyContext } from 'Components/tracked/DirtyContext';
import * as UIStateSelectors from 'Common/UI/state/selectors';

class AppHeaderContainer extends React.Component {
  render() {
    const { headerDisplay, districtName } = this.props;
    return (
      headerDisplay && (
        <DirtyContext.Consumer>
          {({ getPageLevelDirty, setPageLevelDirty }) => (
            <header id="app-header">
              <AppHeaderLogo getPageLevelDirty={getPageLevelDirty} />
              <section id="app-header-contents">
                <SemanticHeader as="h3" className="inline-block">
                  {districtName}
                </SemanticHeader>
                <AppHeaderControls
                  notificationCount={4}
                  getPageLevelDirty={getPageLevelDirty}
                />
                <Grid columns={2}>
                  <Grid.Row>
                    <Grid.Column />
                    <Grid.Column />
                  </Grid.Row>
                </Grid>
              </section>
            </header>
          )}
        </DirtyContext.Consumer>
      )
    );
  }
}

const mapStateToProps = state => ({
  districtName: state.SecurityState.userInfo.districtName,
  headerDisplay: UIStateSelectors.getHeaderDisplay(state),
});

export const Header = connect(mapStateToProps)(AppHeaderContainer);



// WEBPACK FOOTER //
// ./src/containers/app/Header.js